import React from "react";
import { Grid, Typography, makeStyles } from "@material-ui/core";
import Modal from "./Modal";
import CustomTextField from "./CustomTextField";
import { GRAY } from "../../theme";

const ReasonForEditConfirmationModal = props => {
  const {
    secondaryButtonColor,
    secondaryButtonText,
    primaryButtonText,
    handleOpenClose,
    secondaryAction,
    loadingContent,
    primaryAction,
    shouldCancel,
    openedModal,
    shouldExit,
    titleIcon,
    subtitle,
    loading,
    success,
    title,
    reasonForEdit = "",
    handleReasonForEdit,
    reasonForEditError,
    reasonForEditHelperText,
    disablePrimaryButton = false
  } = props;
  const classes = useStyles({ secondaryButtonColor });

  return (
    openedModal && (
      <Modal
        primaryButton={
          primaryButtonText
            ? {
                action: () => primaryAction(reasonForEdit),
                text: primaryButtonText,
                variant: "contained",
                color: "primary",
                disabled: disablePrimaryButton || !reasonForEdit.trim()
              }
            : null
        }
        secondaryButton={
          secondaryButtonText
            ? {
                action: () => secondaryAction(),
                text: secondaryButtonText,
                variant: "outlined",
                color: secondaryButtonColor,
                className: classes.secondaryButton
              }
            : null
        }
        openedModal={openedModal}
        closeModal={() => handleOpenClose()}
        title={title}
        titleIcon={titleIcon}
        closeIcon
        shouldCancel={shouldCancel}
        shouldExit={shouldExit}
        success={success}
        loadingPrimaryButton={loading}
        loadingContent={loadingContent}
      >
        {subtitle && (
          <Typography variant="body1" align="center" className={classes.colorSubtitle}>
            {subtitle}
          </Typography>
        )}

        <Grid container className={classes.reasonForEditContainer}>
          <Grid item xs={12}>
            <CustomTextField
              required
              label="Motivo da edição"
              placeholder="Descreva aqui..."
              value={reasonForEdit}
              onChange={handleReasonForEdit}
              error={reasonForEditError}
              helperText={reasonForEditHelperText}
              inputProps={{
                "aria-label": "Digite o motivo da edição"
              }}
              maxLength={255}
              multiline
              rows={3}
            />
          </Grid>
        </Grid>
      </Modal>
    )
  );
};

const useStyles = makeStyles({
  colorSubtitle: {
    color: GRAY
  },
  secondaryButton: ({ secondaryButtonColor }) => ({
    color: secondaryButtonColor,
    borderColor: secondaryButtonColor
  }),
  reasonForEditContainer: {
    marginTop: 24
  }
});

export default ReasonForEditConfirmationModal;
